export interface BookingCalendarEvent {
  bookingId: string;
  address: string;
  startTime: Date | string;
  endTime: Date | string;
}

function formatIcsDate(date: Date): string {
  return date
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}Z$/, 'Z');
}

function escapeIcsText(value: string): string {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');
}

function foldIcsLine(line: string): string {
  const chunks: string[] = [];
  let remaining = line;

  while (remaining.length > 75) {
    chunks.push(remaining.slice(0, 75));
    remaining = remaining.slice(75);
  }

  chunks.push(remaining);
  return chunks.join('\r\n ');
}

function createBookingIcs(event: BookingCalendarEvent): string {
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//AtomFit//Booking//CS',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${escapeIcsText(`atomfit-booking-${event.bookingId}@atomfit`)}`,
    `DTSTAMP:${formatIcsDate(new Date())}`,
    `DTSTART:${formatIcsDate(new Date(event.startTime))}`,
    `DTEND:${formatIcsDate(new Date(event.endTime))}`,
    `SUMMARY:${escapeIcsText('Tvůj trénink v AtomFitu')}`,
    `LOCATION:${escapeIcsText(event.address)}`,
    'DESCRIPTION:Rezervace AtomFit',
    'END:VEVENT',
    'END:VCALENDAR',
  ];

  return `${lines.map(foldIcsLine).join('\r\n')}\r\n`;
}

function createBookingIcsFilename(event: BookingCalendarEvent): string {
  const datePart = new Date(event.startTime).toISOString().slice(0, 10);
  return `atomfit-rezervace-${datePart}.ics`;
}

export function downloadBookingIcs(event: BookingCalendarEvent): void {
  const blob = new Blob([createBookingIcs(event)], {
    type: 'text/calendar;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = createBookingIcsFilename(event);
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
